import React from "react";
import { dashboardTheme } from "../../../../themes";
import DashboardFab from "../navigation/DashboardFab";
import DashboardHeader from "../headers/DashboardHeader";
import DashboardDrawer from "../sidebars/DashboardDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DashboardBottomMenu from "../navigation/DashboardBottomMenu";
import AccessControl from "../../../../components/AccessControl";
import Background from "../../../../assets/img/bg-wave.png";
import { UserRole } from "../../../user/enums/UserRole";

const DashboardLayout = ({ showCart, hideHeaderItems = false, children }) => {
  const matches = useMediaQuery(dashboardTheme.breakpoints.down("sm"));

  return (
    <>
      <DashboardHeader showCart={showCart} hideHeaderItems={hideHeaderItems} />
      <AccessControl
        allowedRoles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
      >
        <DashboardDrawer />
      </AccessControl>
      <div
        style={{
          paddingTop: 119,
          marginBottom: dashboardTheme.spacing(9),
          backgroundImage: `url("${Background}")`,
          backgroundColor: "transparent",
          backgroundSize: "100% auto",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 10em",
          backgroundAttachment: "fixed",
        }}
      >
        {children}
      </div>
      <AccessControl
        allowedRoles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
      >
        <DashboardFab />
      </AccessControl>
      {matches && (
        <AccessControl
          verified={false}
          allowedRoles={[
            UserRole.Agent,
            UserRole.School,
            UserRole.ServiceProvider,
            UserRole.Teacher,
            UserRole.Student,
          ]}
        >
          <DashboardBottomMenu />
        </AccessControl>
      )}
    </>
  );
};

export default React.memo(DashboardLayout);
